import Header from './components/Header';
import Hero from './components/Hero';
import { SectionApp, SectionContact, SectionAbout, SectionFeatures } from './components/SmallSections';
import CardsSection from './components/CardSections';
import { SectionMedia, SectionCarousel } from './components/CardSections';
import CommentsSection from './components/CommentsSection';
import { SectionUpdates, SectionRanking } from './components/ListSections';
import { SectionIndex, SectionFAQ, SectionTopics } from './components/ContentSections';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <SectionApp />

        <SectionContact />

        <CardsSection />

        <CommentsSection />

        <SectionUpdates />

        <SectionRanking />

        <SectionIndex />

        <SectionAbout />

        <SectionMedia />

        <SectionFAQ />

        <SectionFeatures />

        <SectionTopics />

        <SectionCarousel />
      </main>

      <Footer />
    </div>
  );
}